module.exports = __webpack_public_path__ + "img/main_bg.bf58dab4.png";